import React, { useEffect, useState } from 'react';
import { styled } from '@mui/material';

import { FormLabel, Radio, RadioGroup, Stack } from 'shell/components';

const LikertScaleQuestion = ({ id, question, itemList, defaultItem, review, handleSelected }) => {
    const [selectedItem, setSelectedItem] = useState({ key: '', value: 'Select' });

    const handleSelectedItem = (e) => {
        let data = itemList.find(({ key }) => key === e.target.value);
        const number = itemList.findIndex(({ key }) => key === e.target.value) + 1;
        data = { ...data, number };
        setSelectedItem(data);
        handleSelected(data);
    };

    useEffect(() => {
        if (defaultItem) setSelectedItem(defaultItem);
    }, [defaultItem]);

    return (
        <Stack spacing={2}>
            <CustomFormLabel id={`${id}-label`} variant={'p2'}>
                {question}
            </CustomFormLabel>
            <CustomRadioGroup aria-labelledby={`${id}-label`} value={selectedItem.key} onChange={handleSelectedItem}>
                {(itemList || []).map(({ key, value }) => (
                    <Radio key={key} disabled={review} label={value} labelPlacement={'bottom'} value={key} />
                ))}
            </CustomRadioGroup>
        </Stack>
    );
};

const CustomFormLabel = styled(FormLabel)(({ theme }) => {
    return {
        color: theme.palette.ensightful.neutral[900],
        wordBreak: 'break-word',
    };
});

const CustomRadioGroup = styled(RadioGroup)(() => {
    return {
        flexDirection: 'row',
        justifyContent: 'space-evenly',
    };
});

export default LikertScaleQuestion;
